import { call, put, select, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import logger from '@elab/core/utils/logger';
import { datePickerConstants } from '@elab/core/utils/constants';

import types, { DATE_FROM, DATE_TO } from './types';
import selectors from './selectors';
import * as actions from './actions';

const api = process.env.NODE_ENV === 'development' ? require('./api.mock') : require('./api');

export function* getQueryParams() {
    const dateFrom = yield select(selectors.getDataFieldValue, DATE_FROM);
    const dateTo = yield select(selectors.getDataFieldValue, DATE_TO);
    const dates = dateFrom && dateTo ? { dateFrom, dateTo } : {};
    return {
        ...dates,
        pageSize: yield select(selectors.getPageSize),
        pageNumber: yield select(selectors.getRequestedPageNumber),
    };
}

function* resetDates() {
    yield put(actions.blurField(DATE_FROM));
    yield put(actions.blurField(DATE_TO));
    yield put(actions.resetData());
    yield call(getHistory);
}

export function* cancelDate({ payload: fieldName }) {
    if (fieldName === DATE_TO) {
        yield put(actions.focusField(DATE_FROM));
    } else if (fieldName === DATE_FROM) {
        const dateFrom = yield select(selectors.getDataFieldValue, DATE_FROM);
        const dateTo = yield select(selectors.getDataFieldValue, DATE_TO);
        if (dateFrom !== null && dateTo === null) {
            yield put(actions.resetData());
        }
    }
}

function* focusDate({ payload: fieldName }) {
    const dateFrom = yield select(selectors.getDataFieldValue, DATE_FROM);
    if (dateFrom === null && fieldName === DATE_TO) {
        yield put(actions.blurField(DATE_TO));
        yield put(actions.focusField(DATE_FROM));
    }
}

export function* updateDates() {
    const dateFrom = yield select(selectors.getDataFieldValue, DATE_FROM);
    const dateTo = yield select(selectors.getDataFieldValue, DATE_TO);
    if (
        moment(dateTo, datePickerConstants.DEFAULT_FORMAT).isBefore(
            moment(dateFrom, datePickerConstants.DEFAULT_FORMAT),
        )
    ) {
        yield put(actions.setDataFieldValue(DATE_TO, dateFrom, true));
        return;
    }
    if (dateFrom === null) {
        yield put(actions.focusField(DATE_FROM));
    } else if (dateTo === null) {
        yield put(actions.focusField(DATE_TO));
    } else {
        yield put(actions.resetRecords());
        yield call(getHistory);
    }
}

export function* getHistory() {
    const queryParams = yield call(getQueryParams);
    try {
        const response = yield call(api.getLoyaltyCardHistory, queryParams);
        yield put(actions.updateLoyaltyCardHistoryList(response));
    } catch (error) {
        yield call(logger.error, error);
    }
}

export default () => [
    takeLatest([types.SET_PAGE_SIZE, types.SHOW_MORE], getHistory),
    takeLatest(types.RESET, resetDates),
    takeLatest(types.CANCEL, cancelDate),
    takeLatest(types.FOCUS_FIELD, focusDate),
    takeLatest(types.SET_DATA_FIELD_VALUE, updateDates),
];
